/* Full review text stays in server HTML; enhance with five-row pages. */
(function () {
  'use strict';
  if (window.btmReviewListV4Loaded) return;
  window.btmReviewListV4Loaded = true;
  function init(scope) {
    scope.querySelectorAll('[data-btm-reviews]').forEach(function (root) {
      if (root.dataset.ready === 'v4') return;
      var list = root.querySelector('[data-list]');
      var controls = root.querySelector('[data-controls]');
      var pager = root.querySelector('[data-pagination]');
      if (!list || !controls || !pager) return;
      root.dataset.ready = 'v4';
      var rows = Array.from(list.querySelectorAll('[data-review]')).map(function (el, index) {
        var timestamp = Date.parse(el.dataset.date);
        return {el: el, index: index, rating: Number(el.dataset.rating), comment: el.dataset.comment === 'true', date: Number.isFinite(timestamp) ? timestamp : null};
      });
      if (!rows.length) return;
      var order = 'relevant';
      var menu = controls.querySelector('[data-sort-menu]');
      if (!menu) return;
      var page = 1, size = 5, pages = Math.ceil(rows.length / size);
      function byDate(a, b, ascending) {
        if (a.date === null && b.date !== null) return 1;
        if (b.date === null && a.date !== null) return -1;
        return (a.date !== null && b.date !== null ? (ascending ? a.date - b.date : b.date - a.date) : 0) || a.index - b.index;
      }
      function button(label, dest, aria, disabled) {
        var b = document.createElement('button');
        b.type = 'button'; b.textContent = label; b.dataset.page = dest;
        b.setAttribute('aria-label', aria); b.disabled = !!disabled;
        if (label === String(page)) b.setAttribute('aria-current', 'page');
        pager.appendChild(b);
      }
      function update() {
        var ordered = rows.slice().sort(function (a, b) {
          if (order === 'relevant') {
            // Group reviews with comments first; within that group, place 1–2 star
            // reviews after 3–5 star reviews. Ratings without comments come last.
            var aLow = a.rating >= 1 && a.rating <= 2;
            var bLow = b.rating >= 1 && b.rating <= 2;
            return Number(b.comment) - Number(a.comment)
              || (a.comment && b.comment ? Number(aLow) - Number(bLow) : 0)
              || byDate(a, b, false);
          }
          if (order === 'best') return b.rating - a.rating || Number(b.comment) - Number(a.comment) || byDate(a, b, false);
          if (order === 'worst') return a.rating - b.rating || Number(b.comment) - Number(a.comment) || byDate(a, b, false);
          return byDate(a, b, false);
        });
        var start = (page - 1) * size;
        var fragment = document.createDocumentFragment();
        ordered.forEach(function (r, i) { r.el.hidden = i < start || i >= start + size; fragment.appendChild(r.el); });
        list.appendChild(fragment);
        root.querySelector('[data-status]').textContent = (start + 1) + '–' + Math.min(start + size, rows.length) + ' z ' + rows.length + ' hodnocení';
        pager.replaceChildren(); pager.hidden = pages <= 1;
        if (pages <= 1) return;
        button('‹', page - 1, 'Předchozí stránka', page === 1);
        var previous = 0;
        for (var n = 1; n <= pages; n++) {
          if (n !== 1 && n !== pages && Math.abs(n - page) > 1) continue;
          if (previous && n - previous > 1) { var dots = document.createElement('span'); dots.textContent = '…'; dots.setAttribute('aria-hidden', 'true'); pager.appendChild(dots); }
          button(String(n), n, 'Stránka ' + n, false); previous = n;
        }
        button('›', page + 1, 'Další stránka', page === pages);
      }
      pager.addEventListener('click', function (event) {
        var b = event.target.closest('button[data-page]');
        if (!b || b.disabled) return;
        var dest = Number(b.dataset.page);
        if (dest < 1 || dest > pages || dest === page) return;
        page = dest; update();
        list.tabIndex = -1; list.focus({preventScroll: true});
        var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        controls.scrollIntoView({behavior: reduced ? 'auto' : 'smooth', block: 'start'});
      });
      menu.addEventListener('click', function (event) {
        var choice = event.target.closest('button[data-order]');
        if (!choice) return;
        order = choice.dataset.order;
        menu.querySelector('[data-sort-label]').textContent = choice.textContent;
        menu.querySelectorAll('[data-order]').forEach(function (button) { button.setAttribute('aria-pressed', String(button === choice)); });
        page = 1; update(); menu.open = false; menu.querySelector('summary').focus({preventScroll: true});
      });
      menu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') { event.preventDefault(); menu.open = false; menu.querySelector('summary').focus(); }
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault(); menu.open = true;
          var choices = Array.from(menu.querySelectorAll('[data-order]'));
          var index = choices.indexOf(document.activeElement);
          choices[(index + (event.key === 'ArrowDown' ? 1 : choices.length - 1) + choices.length) % choices.length].focus();
        }
      });
      controls.hidden = false; update();
    });
  }
  document.addEventListener('click', function (event) {
    document.querySelectorAll('[data-sort-menu][open]').forEach(function (menu) { if (!menu.contains(event.target)) menu.open = false; });
    var link = event.target.closest('[data-btm-review-link]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    var target = document.getElementById(link.hash.slice(1));
    if (!target) return;
    event.preventDefault();
    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.focus({preventScroll: true});
    target.scrollIntoView({behavior: reduced ? 'auto' : 'smooth', block: 'start'});
    // Keep the anchor usable when users copy the URL or navigate back.
    if (window.location.hash !== link.hash) window.history.pushState(null, '', link.hash);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
